import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  readonly rootUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  setHeaders(parameters?: any) {

    let headers = new HttpHeaders({ parameters });
    return headers;
  }

  setParams(parameters:any) {
    let params = new HttpParams();
    if (parameters) {
      for (const i in parameters) {
        if (parameters[i] != null) {
          params = params.append(i, parameters[i]);
        }
      }
    }
    return params;
  }

  get(url: string): Observable<any> {      
    return this.http.get<any>(`${this.rootUrl}/${url}`);
  }


  post(url: string, data: any, parameters?: any): Observable<any> {
    const headers = this.setHeaders(data);
    const params = this.setParams(parameters);
    return this.http.post<any>(`${this.rootUrl}/${url}`, data, { headers, params });
  }

  put(url: string, data: any): Observable<any> {
    const headers = this.setHeaders();
    return this.http.put<any>(`${this.rootUrl}/${url}`, data, {headers});
  }

  update(url: string, objectId: string, data: any): Observable<any> {
    const headers = this.setHeaders();
    return this.http.patch<any>(`${this.rootUrl}/${url}/${objectId}`, data, {headers});
  }

  delete(url: string, objectId: string): Observable<any> {
    const headers = this.setHeaders();
    return this.http.delete(`${this.rootUrl}/${url}/${objectId}`, {headers});
  }
  
}
